import React from 'react'
import IssueSolutionMeta from './IssueSolutionMeta'
import { useParams, useLocation, Link } from 'react-router-dom'
import { calcReadingTime, milisToMinutesOrSeconds, pluralize } from '../../utils/util'
import { ReactComponent as LeftArrow } from '../../svg/normalSvgs/LeftArrow.svg'
import '../../styles/OtherStudentIssueSolutions.css'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import TaskMascot from '../../svg/UpstriveTaskMaskot'

export default function OtherStudentsIssueSolutions(props) {
    const { t } = useTranslation()
    const { state: solutions } = useLocation()
    const { id } = useParams()

    const IssueSolutionItem = ({ solution }) => {
        const numOfLikes = solution.likes
        const soundDuration = solution.audio_file && solution.audio_file.duration
        const calcEstimatedTime = () => {
            if (soundDuration) {
                return milisToMinutesOrSeconds(soundDuration)
            } else {
                const readingTime = calcReadingTime(solution.text_body)
                return `${readingTime} ${pluralize('minute', readingTime)} ${t('read')}`
            }
        }

        return (
            <div className="other-student-solution-container shadow-custom-soft">
                {solution.expert_recomendation && <div className="solution-item-label">{t('expertRecommendation')} </div>}
                <div className="other-student-solution-item-title">{`\n${solution.title}`}</div>
                <div className="solution-item-text">{!!solution.text_body && <div>{solution.text_body}</div>}</div>
                <div className="solution-item-text-meta">
                    <IssueSolutionMeta estimatedTime={calcEstimatedTime()} numOfLikes={numOfLikes} hasSound={!!soundDuration} />
                </div>
            </div>
        )
    }

    return (
        <div className={`other-student-solutions-container  ${i18n.language == 'ar' ? 'ar-lang' : ''}`}>
            <div className="other-student-solutions-title shadow-custom-soft">
                {/* TODO: CHANGE ICON */}
                <span className="other-student-arrow">
                    <Link to={`/solutions/${id}`}>
                        <LeftArrow className={`${i18n.language == 'ar' ? 'ar-transform' : ''}`} />
                    </Link>
                </span>
                <span className="other-student-solutions-text">{t('seeHowOtherStudentsHandleThis')}</span>
            </div>
            <div className="other-student-solutions-list grey-small-scroll">
                {solutions.map((solution, i) => (
                    <IssueSolutionItem solution={solution} key={i} />
                ))}
            </div>
        </div>
    )
}
